import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { PaymentAccountConfigBaseComponent } from '../payment-account-config-base/payment-account-config-base.component';
import { CityHallSystemPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/cityhallsystem/cityhallsystem-payment-processor-account-configuration';

@Component({
  selector: 'wm-payment-account-config-cityhallsystem',
  templateUrl: './payment-account-config-cityhallsystem.component.html',
  // styleUrls: ['./payment-account-config-cityhallsystem.component.css'],
  standalone: false
})
export class PaymentAccountConfigCityHallSystemComponent
  extends PaymentAccountConfigBaseComponent
  implements OnInit {
  @Input() config: CityHallSystemPaymentProcessorAccountConfiguration;

  constructor(fb: UntypedFormBuilder) {
    super(fb);

    // Hide the base username/password fields
    // since CityHallSystem uses its own User and Password fields.
    this.showUsername = false;
    this.showPassword = false;
  }

  ngOnInit() {
    if (!this.config) {
      this.config = new CityHallSystemPaymentProcessorAccountConfiguration();
    }

    // Required fields
    this.addValidation('vendorId', Validators.required, this.config.vendorId);
    this.addValidation('user', Validators.required, this.config.user);
    this.addValidation('password', Validators.required, this.config.password);

    // Keep config in sync with form
    this.form.valueChanges.subscribe(values => {
      Object.assign(this.config, values);
    });
  }
}
